import React from 'react';
import styles from './Table.module.less';
export var wrapWithAlign = function wrapWithAlign(align, children) {
  if (!align) return children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles["align-".concat(align)]
  }, children);
};